//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getSpeakersArray from '@/utils/event/getSpeakersArray';
import Speaker from './speaker.vue';

export default {
  components: { Speaker },
  data() {
    return {
      schedule: [],
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    topics() {
      return this.event?.topics;
    },
  },
  created() {
    this.createChedule();
  },
  methods: {
    formatDate(textUtcDate) {
      return this.$dayjs
        .utc(textUtcDate)
        .utcOffset(this.$app.config.current.utcOffset)
        .format('DD [de] MMMM, HH:mm');
    },
    createChedule() {
      const items = [];

      const speakers = getSpeakersArray(this.event);
      let onlyOneSpeaker = speakers.length === 1;

      for (let i = 0; i < this.topics.length; i++) {
        const topic = this.topics[i];

        // Если спикер у ивента всего один - не показываем его в расписании
        if (onlyOneSpeaker) {
          items.push({ topic });
        } else {
          const speaker = speakers.find((i) => i.topic_num === topic.num);
          items.push({
            topic,
            speaker,
          });
        }
      }

      this.schedule = items;
    },
  },
};
